'use client';

import useTransition from './useTransition.js';

function useDropdownAnimation(open, placement) {
    var side = placement.split('-')[0];
    var _a = useTransition({
        open: open,
        args: {
            side: side
        }
    }, {
        initial: function (_a) {
            var side = _a.side;
            return {
                opacity: 0,
                transform: 'scaleY(0)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        },
        enter: function (_a) {
            var side = _a.side;
            return {
                opacity: 1,
                transform: 'scaleY(1)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        },
        leave: function (_a) {
            var side = _a.side;
            return {
                opacity: 0,
                transform: 'scaleY(0)',
                transformOrigin: side === 'top' ? 'bottom' : 'top'
            };
        }
    }), isMounted = _a.isMounted, styles = _a.styles;
    return { isMounted: isMounted, styles: styles };
}

export { useDropdownAnimation as default };
//# sourceMappingURL=useDropdownAnimation.js.map
